













































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default Vue.extend({
  name: "SettingMenuModal",
  data() {
    return {
      searchDebounce: null,
      search: "",
      selected: [],
      file: null,
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000]
    };
  },
  computed: {
    ...mapGetters({
      users: "user/users",
      loadingUsers: "user/loadingUsers",
      count: "user/count",
      upLoading: "user/upCSVLoading"
    })
  },
  methods: {
    openModalChangePass(id: string) {
      this.setChangePassModal(true);
      this.setChangePassID(id);
      this.getUserInfo(id);
    },
    ...mapMutations({
      openModalAdd: "user/openModalAdd",
      openModalEdit: "user/openModalEdit",
      setChangePassModal: "user/setChangePassModal",
      setChangePassID: "user/setChangePassID",
      showSettingModal: "user/showSettingModal",
      setUserIdSettingModal: "user/setUserIdSettingModal",
      getUserMenu: "user/getUserMenu"
    }),
    ...mapActions({
      deleteUser: "user/deleteUser",
      deleteListUser: "user/deleteListUser",
      pageChange: "user/pageChange",
      perPageChange: "user/perPageChange",
      searchUser: "user/searchUser",
      upLoadCSV: "user/upLoadCSV",
      getCSVTemplate: "user/getCSVTemplate",
      changeStatusCard: "user/changeStatusCard",
      changeUsername: "user/changeUsername"
    }),
    showSettingMenuModal(userId: string) {
      this.showSettingModal();
      this.setUserIdSettingModal(userId);
      this.getUserMenu(userId);
    },

    removeSelected() {
      const selectedId = this.selected.map(item => item._id);
      this.deleteListUser(selectedId);
    },
    createWhiteList() {},

    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.searchUser(this.search);
      }, 500);
    },
    handleChangeUsername(id: string) {
      this.$buefy.dialog.prompt({
        message: `Tên đăng nhập mới?`,
        confirmText: "Lưu",
        cancelText: "Hủy",
        inputAttrs: {
          placeholder: "vd: admin"
        },
        trapFocus: true,
        onConfirm: value => this.changeUsername({ id: id, value: value })
      });
    },

    onPageChange(page) {
      this.pageChange(page);
    },
    perPageChanged() {
      this.perPageChange(this.perPage);
    },
    upload() {
      this.upLoadCSV(this.file);
    }
  }
});
